/** @file Event timeline sampler: collects key indices fired in [lastTime, time), splitting a wrapped loop. */
import type { Sample } from '../../contracts/sample';
import type { TimelineHandler } from '../../contracts/timeline';

/** Appends key index i to out.events while capacity remains (createSample sizes it to the largest timeline). */
function fire(out: Sample, i: number): void {
  if (out.eventCount < out.events.length) out.events[out.eventCount++] = i;
}

/** Fires keys in [lastTime, time) in key order; when lastTime > time (loop wrap) keys >= lastTime first, then < time. */
export const eventHandler: TimelineHandler<'event'> = {
  sample(tl, time, lastTime, out) {
    const times = tl.times;
    if (lastTime <= time) {
      for (let i = 0; i < times.length; i++) {
        const t = times[i] ?? 0;
        if (t >= lastTime && t < time) fire(out, i);
      }
      return;
    }
    for (let i = 0; i < times.length; i++) if ((times[i] ?? 0) >= lastTime) fire(out, i);
    for (let i = 0; i < times.length; i++) if ((times[i] ?? 0) < time) fire(out, i);
  },
};
